export const NOT_IMPLEMENTED_EXCEPTION = new Error("Not implemented in backend");
